<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Reporte de autorizaciones</h4>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-md-3">
            <small> Fecha inicial: </small>
            <input type="date" class="form-control" v-model="fechainicio" />
          </div>
          <div class="col-md-3">
            <small> Fecha final: </small>
            <input type="date" class="form-control" v-model="fechafin" />
          </div>
          <div class="col-md-3" v-if="rol == 1">
            <small for="">Sede:</small>
            <select class="form-control" v-model="sede">
              <option
                v-for="sede in SedesProgramacion"
                :key="sede.sede"
                :value="sede.sede"
              >
                {{ sede.sede }}
              </option>
            </select>
          </div>
          <div class="col-md-1">
            <br />
            <button
              class="btn btn-success btn-fill"
              style="border-radius: 0px"
              @click="getInformation()"
            >
              <i class="fa fa-search"></i> Buscar
            </button>
          </div>
          <div class="col-md-2">
            <!-- <button class="btn btn-success btn-sm">
                  <i color="black" class="fa fa-download"></i> Exportar
                </button> -->
            <br />
            <download-excel
              class="btn btn-primary btn-fill"
              style="border-radius: 0px"
              :data="json_data"
              :fields="json_fields"
              worksheet="My Worksheet"
              :name="
                'Reporte-autorizaciones' + '-' + fechainicio + '-' + fechafin
              "
              v-if="json_data != ''"
            >
              Exportar a excel
            </download-excel>
          </div>
        </div>
        <div class="row">
          <br />
          <div class="col-md-12">
            <el-table
              class=""
              size="mini"
              :data="queriedData"
              max-height="500"
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="130" label="Fecha de registro">
                <template slot-scope="props">
                  {{ props.row.created_at.substring(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column :min-width="160" label="Observaciones">
                <template slot-scope="props">
                  {{ props.row.observaciones }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    fechainicio: "",
    fechafin: "",
    sede: "",
    SedesProgramacion: [],
    ip: "https://avanti-erp.com/",
    rol: '',

    // tabla
    queriedData: [],
    tableColumns: [
      {
        prop: "nombre_paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Nombres", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "apellidos_paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Apellidos", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "codigo", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Autorizacion", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 130, //ANCHO DE LA COLUMNA
      },
      {
        prop: "entidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Entidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      // {
      //   prop: "created_at", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
      //   label: "Fecha ingreso", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
      //   minWidth: 130 //ANCHO DE LA COLUMNA
      // },
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha expedición", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 130, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fecha_vencimiento", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha vencimiento", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "pertenece", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Orden", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "servicio", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "servicio", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 160, //ANCHO DE LA COLUMNA
      },
      {
        prop: "cantidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "SSA", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        // minWidth: 150 //ANCHO DE LA COLUMNA
      },
      {
        prop: "consumidas", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "SSR", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        // minWidth: 150 //ANCHO DE LA COLUMNA
      },
      {
        prop: "tipo", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Tipo", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 120, //ANCHO DE LA COLUMNA
      },
      {
        prop: "usuario", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Usuario", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        // minWidth: 150 //ANCHO DE LA COLUMNA
      },
    ],
    json_fields: {
      "Nombres del paciente": "paciente",
      // "Apellidos del paciente" : "apellidos_paciente",
      autorizacion: "codigo",
      Entidad: "entidad",
      "Fecha de registro": "fecha_ingreso",
      "Fecha expedición": "Fecha",
      "Fecha vencimiento": "Fecha_vencimiento",
      orden: "pertenece",
      servicio: "servicio",
      cantidad: "cantidad",
      SSR: "consumidas",
      Tipo: "tipo",
      usuario: "usuario",
      observaciones: "observacion",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    getInformation() {
      this.$modal.show("carga");
      this.queriedData = [];
      
      const sede = this.rol == 1 ? this.sede : localStorage.getItem("sede");
      const BASE_URL = `${this.ip}api/reporteAutorizaciones/${this.fechainicio}/${this.fechafin}/${sede}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          let datos = [];
          this.queriedData = res.data.data;
          // console.log(res.data.data);
          for (let index = 0; index < res.data.data.length; index++) {
            datos.push({
              paciente:
                res.data.data[index].nombre_paciente +
                " " +
                res.data.data[index].apellidos_paciente,
              codigo: res.data.data[index].codigo,
              entidad: res.data.data[index].entidad,
              Fecha: res.data.data[index].fecha,
              Fecha_vencimiento: res.data.data[index].fecha_vencimiento,
              pertenece: res.data.data[index].pertenece,
              servicio: res.data.data[index].servicio,
              cantidad: res.data.data[index].cantidad,
              consumidas: res.data.data[index].consumidas,
              tipo: res.data.data[index].tipo,
              usuario: res.data.data[index].usuario,
              fecha_ingreso: res.data.data[index].created_at.substring(0, 10),
              observacion: res.data.data[index].observaciones,
            });
          }

          this.json_data = datos;
          this.$modal.hide("carga");
          // console.log('datos', datos)
        })
        .catch((err) => {
          console.log(err);
          this.$modal.hide("carga");
        });
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted(){
    this.rol = localStorage.getItem("rol");
    this.emailsProgramacion();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reportes/Autorizaciones.vue